import React from 'react';

function ApplicationReports(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 7H2C1.44772 7 1 7.44772 1 8V20C1 20.5523 1.44772 21 2 21H17C17.5523 21 18 20.5523 18 20V19H4C3.44772 19 3 18.5523 3 18V7Z"
        fill="white"
        fillOpacity="0.25"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 5H4C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H19C19.5523 19 20 18.5523 20 18V17H6C5.44772 17 5 16.5523 5 16V5Z"
        fill="white"
        fillOpacity="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4C5 3.44772 5.44772 3 6 3H22C22.5523 3 23 3.44772 23 4V16C23 16.5523 22.5523 17 22 17H6C5.44772 17 5 16.5523 5 16V4ZM13 7C13.5523 7 14 7.44772 14 8V13C14 13.5523 13.5523 14 13 14C12.4477 14 12 13.5523 12 13V8C12 7.44772 12.4477 7 13 7ZM11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10V13C9 13.5523 9.44772 14 10 14C10.5523 14 11 13.5523 11 13V10ZM16 9C16.5523 9 17 9.44772 17 10V13C17 13.5523 16.5523 14 16 14C15.4477 14 15 13.5523 15 13V10C15 9.44772 15.4477 9 16 9ZM20 8C20 7.44772 19.5523 7 19 7C18.4477 7 18 7.44772 18 8V13C18 13.5523 18.4477 14 19 14C19.5523 14 20 13.5523 20 13V8Z"
        fill="white"
      />
      <path
        d="M13 8V13"
        stroke="white"
        strokeOpacity="0.25"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M10 10V13"
        stroke="white"
        strokeOpacity="0.25"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16 10V13"
        stroke="white"
        strokeOpacity="0.25"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M19 8L19 13"
        stroke="white"
        strokeOpacity="0.25"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default ApplicationReports;
